import * as React from "react";
import IssuerInfo from "./IssuerInfo/IssuerInfo";
import classNames from "classnames";
import useAppSelector from "../hooks/useAppSelector";
export default function IssuerHeader(_a) {
    var style = _a.style, issuer = _a.issuer, className = _a.className;
    var defaultIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.auto; });
    var selectedIssuer = issuer || defaultIssuer;
    if (!(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id)) {
        return null;
    }
    var id = selectedIssuer.id, name = selectedIssuer.name, site = selectedIssuer.site;
    return (React.createElement("div", { className: classNames("w-full p-6 desktop:px-4 desktop:py-6 sm-md:px-4 sm-md:py-6", className), style: style },
        React.createElement(IssuerInfo, { id: id, name: name, site: site })));
}
